function ExperienceList({children}){
    return(
        <>
        <li className="font-normal font-circular text-base text-gray-500 dark:text-gray-400">{children}</li>
        </>
    );
}

export default ExperienceList;